import { render, staticRenderFns } from "./Appetite.vue?vue&type=template&id=4f8b534c"
import script from "./Appetite.vue?vue&type=script&lang=js"
export * from "./Appetite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports